import { EVM_NETWORKS } from "../network";
import { normalizeAddress } from "../nft";
import { cryptoId, unique } from "../utils";
import { validateWalletAddress, Wallet } from "../wallet";
import { UserBase } from "./base";
export class User extends UserBase {
    constructor(params) {
        super(params);
        this.authId = (params === null || params === void 0 ? void 0 : params.authId) || "";
        this.wallets =
            (params === null || params === void 0 ? void 0 : params.wallets) && (params === null || params === void 0 ? void 0 : params.wallets.length) > 0
                ? params.wallets.map((w) => new Wallet(w))
                : [];
        this.walletAddresses = unique(this.wallets.map((wallet) => wallet.address));
        this.identifiers = unique([
            ...((params === null || params === void 0 ? void 0 : params.identifiers) || []),
            this.email,
            ...this.walletAddresses,
        ]);
        this.networks = unique(this.wallets.map((wallet) => wallet.network));
        this.events = (params === null || params === void 0 ? void 0 : params.events) || [];
        this.moonpassIds = (params === null || params === void 0 ? void 0 : params.moonpassIds) || [];
        this.session = (params === null || params === void 0 ? void 0 : params.session) || "";
        if (params === null || params === void 0 ? void 0 : params.username)
            this.username = params.username;
        if (params === null || params === void 0 ? void 0 : params.source)
            this.source = params.source;
        this.updateWalletAddresses();
    }
    get evmWallets() {
        return this.wallets
            .filter((wallet) => EVM_NETWORKS.includes(wallet.network))
            .sort((a, b) => b.connectedAt - a.connectedAt)
            .map((wallet) => wallet.address);
    }
    updateNetworks() {
        this.networks = unique(this.wallets.map((wallet) => wallet.network));
    }
    updateWalletAddresses() {
        this.walletAddresses = unique(this.wallets.map((wallet) => wallet.address));
        this.identifiers = unique([...this.identifiers, ...this.walletAddresses]);
        this.updateNetworks();
    }
    update() {
        this.updateWalletAddresses();
        this.updatedAt = new Date().valueOf();
    }
    addWallet(wallet) {
        if (this.isWalletOwner(wallet.network, wallet.address))
            return true;
        if (!validateWalletAddress(wallet.network, wallet.address))
            return false;
        this.wallets.push(wallet);
        this.update();
        return true;
    }
    removeWallet(network, walletAddress) {
        walletAddress = normalizeAddress(network, walletAddress);
        this.wallets = this.wallets.filter((wallet) => wallet.address != walletAddress || wallet.network != network);
        this.update();
        return true;
    }
    removeWalletsByAddress(walletAddress) {
        walletAddress = walletAddress.toLowerCase();
        this.wallets = this.wallets.filter((wallet) => wallet.address.toLowerCase() != walletAddress);
        this.update();
        return true;
    }
    wallet(network, walletAddress) {
        walletAddress = normalizeAddress(network, walletAddress);
        return (this.wallets.find((w) => w.network == network && w.address == walletAddress) || null);
    }
    isWalletOwner(network, address) {
        return !!this.wallet(network, address);
    }
    isNFTOwner(address) {
        return this.walletAddresses
            .map((w) => w.toLowerCase())
            .includes(address.toLowerCase());
    }
    getWalletsByNetwork(network) {
        if (EVM_NETWORKS.includes(network))
            return this.wallets.filter((wallet) => EVM_NETWORKS.includes(wallet.network));
        return this.wallets.filter((wallet) => wallet.network == network);
    }
    getWalletAddressesByNetwork(network) {
        return this.getWalletsByNetwork(network).map((wallet) => wallet.address);
    }
    addMoonpass(moonpassId) {
        if (this.moonpassIds.includes(moonpassId))
            return true;
        this.moonpassIds.push(moonpassId);
        return true;
    }
    removeMoonpass(moonpassId) {
        this.moonpassIds = this.moonpassIds.filter((_moonpassId) => _moonpassId != moonpassId);
        return true;
    }
    isMoonpassOwner(moonpassId) {
        return this.moonpassIds.includes(moonpassId);
    }
    useNewSession(sessionId = "") {
        this.session = `${this.id}:${sessionId || cryptoId(4)}`;
        return this.session;
    }
}
